import Echo from "laravel-echo";
import Pusher from "pusher-js";

import httpClient from "@/services/api/httpClient";

window.Pusher = Pusher;

const token = localStorage.getItem("user-token");

const echo = new Echo({
  broadcaster: "pusher",
  key: process.env.VUE_APP_PUSHER_APP_KEY,
  // wsHost: "hi-backend.test",
  // wsPort: 6001,
  // wssPort: 6001,
  cluster: "eu",
  encrypted: false,
  forceTLS: false,
  disableStats: true,
  enabledTransports: ["ws", "wss"],
  authorizer: (channel, options) => {
    const config = {};
    return {
      authorize: (socketId, callback) => {
        httpClient
          .post("/broadcasting/auth", {
            socket_id: socketId,
            channel_name: channel.name
          })
          .then(response => {
            callback(false, response.data);
          })
          .catch(error => {
            callback(true, error);
          });
      }
    };
  }
});

export default echo;
